import React from 'react';
import { Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import DownIcon from '@mui/icons-material/KeyboardArrowDown';
import UpIcon from '@mui/icons-material/KeyboardArrowUp';

import { setEventsSortDesc } from 'modules/events/store/eventsActions';
import { getEventSortDesc } from 'modules/events/selectors/eventsSelectors';

const useStyle = makeStyles({
  button: {
    height: 45,
    padding: '0 15px',
    fontSize: '0.875rem',
  },
});

const EventsSortSelect = () => {
  const { t } = useTranslation();
  const classes = useStyle();
  const dispatch = useDispatch();
  const sortDesc = useSelector(getEventSortDesc);

  const handleSortingChange = () => dispatch(setEventsSortDesc(!sortDesc));

  return (
    <Button
      variant="contained"
      color="primary"
      className={classes.button}
      onClick={handleSortingChange}
      endIcon={sortDesc ? <UpIcon /> : <DownIcon />}
    >
      {t('Sort by date')}
    </Button>
  );
};

export { EventsSortSelect };
